<template>
  <div>
    <section-card v-for="post in posts" :key="post.id" :post="post" />

    <div
      class="title-section"
      v-bind:class="sClassName"
      @click="getPost"
      v-show="enabled"
    >
      <h3 class="heading-title-sect text-center">
        <span>Más {{ sName }}</span>
      </h3>
    </div>
  </div>
</template>

<script>
import SectionCard from "./../section-card/SectionCard.vue";
import axios from "axios";
import epica from "../../../features/epica";

export default {
  components: { SectionCard },
  props: {
    termId: Number,
    bannedIds: Array,
    initOffset: Number,
    sClassName: String,
    sName: String,
    total: Number,
  },
  created: function () {
    this.tfNews = {};
    this.offset = this.initOffset;
  },
  updated: function () {
    epica();
    document.dispatchEvent(lrLoad);
  },
  mounted: function () {
    this.take = 8;
  },
  methods: {
    getPost: function () {
      this.loading = true;
      var _self = this;
      axios
        .get("/api/pager/term", {
          params: {
            id: this.termId,
            take: this.take,
            offset: this.offset,
            bIds: this.bannedIds,
          },
        })
        .then(function (d) {
          _self.loading = false;
          _self.posts = _self.posts.concat(d.data);
          _self.offset += _self.take;
        });
    },
  },
  computed: {
    enabled: function () {
      return this.offset < this.total && !this.loading;
    },
  },
  data: function () {
    return {
      posts: [],
      loading: false,
    };
  },
};
</script>
